import { render } from "./ModalContentTest.vue?vue&type=template&id=f9b2ed2a&lang=true"
import script from "./ModalContentTest.vue?vue&type=script&lang=js"
export * from "./ModalContentTest.vue?vue&type=script&lang=js"
script.render = render

export default script